import React from "react"
import PropTypes from "prop-types"
import Img from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby"
import ArrowLink from "../components/ArrowLink"

import("../styles/articleCard.scss")

export default function ArticleCard(props) {
  const data = useStaticQuery(graphql`
    query MyQuery {
      defaultArticleImage: file(
        relativePath: { eq: "default-article-image.png" }
      ) {
        childImageSharp {
          fluid(quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  const image =
    props.showImage !== false ? (
      props.image !== null && props.image !== undefined ? (
        <Img className="articleImage" fluid={props.image} />
      ) : (
        <Img
          className="articleImage"
          objectFit="contain"
          fluid={data.defaultArticleImage.childImageSharp.fluid}
        />
      )
    ) : null
  return (
    <div className="articleCard" key={props.title}>
      {image}
      <h4
        className="articleTitle"
        dangerouslySetInnerHTML={{ __html: props.title }}
      />
      <ArrowLink
        className="articleButton"
        href={`/post/${props.slug}`}
        color="black"
        external={false}
      >
        Read More
      </ArrowLink>
    </div>
  )
}

ArticleCard.defaultProps = {
  showImage: true,
}

ArticleCard.propTypes = {
  categories: PropTypes.array,
  title: PropTypes.string,
  image: PropTypes.object,
  slug: PropTypes.string,
  showImage: PropTypes.bool,
}
